import gsap from "gsap";
import lottie from "lottie-web";

function loadLottie(container, onLoaded) {
  // Hide container until Lottie SVG is injected
  container.style.visibility = 'hidden';
  lottie.loadAnimation({
    container: container,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/lottie/25-Years.json',
    rendererSettings: {
      progressiveLoad: true
    },
  }).addEventListener('DOMLoaded', function() {
    container.style.visibility = 'visible';
    if (onLoaded) onLoaded();
  });
}

document.addEventListener("DOMContentLoaded", function () {  
  const divider = document.querySelector('.films-and-year .divider');
  const twentyFive = document.querySelector('.films-and-year .twenty-five');
  const nav = document.querySelector('nav');
  // Update selector to look for .films-and-year inside .scrolling-video-cards
  const filmsAndYear = document.querySelector('.scrolling-video-cards .films-and-year');

  if (twentyFive) {
    loadLottie(twentyFive, function() {
      // Wait for loader to finish, then animate .twenty-five
      const loader = document.querySelector('.loader');
      if (loader && loader.style.display !== 'none') {
        // Listen for loader to be hidden
        const observer = new MutationObserver(() => {
          if (loader.style.display === 'none') {
            animateTwentyFive(twentyFive);
            observer.disconnect();
          }
        });
        observer.observe(loader, { attributes: true, attributeFilter: ['style'] });
      } else {
        // Loader already gone
        animateTwentyFive(twentyFive);
      }
      navInitAfterTimeline(nav);
    });
  } else {
    navInitAfterTimeline(nav);
  }

  // Animate nav .divider in after a short delay
  setTimeout(function() {
    var divider = document.querySelector('.films-and-year .divider');
    if (divider) {
      divider.classList.add('show');
    }
  }, 400); // Adjust delay as needed

  // --- Website List Rotation (moved from nav-website-rotation.js) ---
  const websiteList = document.getElementById('website-list');
  if (websiteList) {
    const yearEl = document.querySelector('.current-slide .year');
    const titleEl = document.querySelector('.current-slide .title');
    // Parse data from #website-list
    const titles = websiteList.getAttribute('data-title')
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map(t => t.trim())
      .filter(Boolean);
    const years = websiteList.getAttribute('data-year')
      .split(',')
      .map(y => y.trim())
      .filter(Boolean);
    // Shuffle indices for random rotation
    const indices = Array.from({ length: Math.max(titles.length, years.length) }, (_, i) => i);
    function shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
    const shuffledIndices = shuffle([...indices]);
    let idx = 0;
    // Animate out text per character
    function animateOutText(el, onComplete) {
      const chars = el.querySelectorAll('span');
      gsap.to(chars, {
        opacity: 0,
        x: 10,
        filter: 'blur(8px)',
        duration: 0.3,
        stagger: 0.01,
        ease: "power2.in",
        onComplete
      });
    }
    // Animate in text per character (like .trailers-title)
    function animateInText(el, text) {
      el.innerHTML = '';
      text.split('').forEach(char => {
        const span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.display = 'inline-block';
        span.style.opacity = 0;
        span.style.filter = 'blur(8px)';
        el.appendChild(span);
      });
      const chars = el.querySelectorAll('span');
      gsap.to(chars, {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        duration: 0.5,
        stagger: 0.03,
        ease: "power2.out",
        delay: 0.1
      });
    }
    function rotateNav() {
      idx = (idx + 1) % shuffledIndices.length;
      const i = shuffledIndices[idx];
      // Animate out title first, then year slightly after
      animateOutText(titleEl, () => animateInText(titleEl, titles[i] || ''));
      setTimeout(() => {
        animateOutText(yearEl, () => animateInText(yearEl, years[i] || ''));
      }, 150); // 150ms delay for a subtle stagger
    }
    // Set initial state with animation
    animateInText(yearEl, years[shuffledIndices[0]] || '');
    animateInText(titleEl, titles[shuffledIndices[0]] || '');
    gsap.set([yearEl, titleEl], { opacity: 1 });
    setInterval(rotateNav, 3000);
  }
});

function navInitAfterTimeline(nav) {
  let lastScroll = window.scrollY;
  let ticking = false;
  const tolerance = 5;
  let accumulatedDelta = 0;

  // Helper: check if .scrolling-video-cards is in viewport
  function isScrollingCardsInView() {
    const scrollingCards = document.querySelector('.scrolling-video-cards');
    if (!scrollingCards) return false;
    const rect = scrollingCards.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function handleNavScroll() {
    // Only allow nav to hide if nav-scroll-enabled is present
    if (!document.body.classList.contains('nav-scroll-enabled')) {
      gsap.to(nav, { y: "0%", duration: 0.4, ease: "power2.out" });
      document.body.classList.remove('scrolled');
      accumulatedDelta = 0;
      lastScroll = window.scrollY;
      ticking = false;
      return;
    }

    const currentScroll = window.scrollY;
    const scrollDelta = currentScroll - lastScroll;
    accumulatedDelta += scrollDelta;

    if (accumulatedDelta > tolerance && currentScroll > 10) {
      gsap.to(nav, { y: "-100%", duration: 0.4, ease: "power2.out" });
      accumulatedDelta = 0;
    } else if (accumulatedDelta < -tolerance) {
      gsap.to(nav, { y: "0%", duration: 0.4, ease: "power2.out" });
      accumulatedDelta = 0;
    }

    if (currentScroll > 0) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(handleNavScroll);
      ticking = true;
    }
  });

  // Modal logic DRY
  const logo = document.getElementById('nav-logo');
  const navModal = document.getElementById('nav-modal');
  let scrollY = 0;
  let restoreNavScrollEnabled = null; // track pre-open state

  const isHomepage = document.body.classList.contains('is-homepage');
  const shouldEnableNavScroll = () => !document.querySelector('.scrolling-video-cards');

  function openModal() {
    // capture state before opening
    restoreNavScrollEnabled = document.body.classList.contains('nav-scroll-enabled');

    scrollY = window.scrollY;
    navModal.classList.add('active');
    document.body.classList.add('modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100vw';
  }

  function closeModal() {
    // Add a short-lived guard so other scroll handlers don't immediately flip classes during close
    document.body.classList.add('nav-scroll-guard');

    navModal.classList.remove('active');
    document.body.classList.remove('modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    // Decide final nav-scroll-enabled state based on current page context
    const scrollingCards = document.querySelector('.scrolling-video-cards');
    let finalShouldEnable = false;
    if (scrollingCards) {
      const boxes = document.querySelectorAll('.trailer-box');
      const lastBox = boxes[boxes.length - 1];
      if (lastBox) {
        const rect = lastBox.getBoundingClientRect();
  const fraction = (typeof window.NAV_SCROLL_FRACTION === 'number') ? window.NAV_SCROLL_FRACTION : 0;
        const threshold = window.innerWidth * (1 - fraction);
        finalShouldEnable = rect.right <= threshold;
      }
    } else {
      // No pinned section present on this page
      finalShouldEnable = true;
    }

    // Apply immediately
    if (finalShouldEnable) {
      document.body.classList.add('nav-scroll-enabled');
    } else {
      document.body.classList.remove('nav-scroll-enabled');
    }

    // Re-apply after a tick and after modal transition to survive layout updates
    requestAnimationFrame(() => {
      if (finalShouldEnable) document.body.classList.add('nav-scroll-enabled');
      else document.body.classList.remove('nav-scroll-enabled');
    });
    setTimeout(() => {
      if (finalShouldEnable) document.body.classList.add('nav-scroll-enabled');
      else document.body.classList.remove('nav-scroll-enabled');
    }, 450);

    // Refresh ScrollTrigger after layout settles
    setTimeout(() => { try { window.ScrollTrigger && window.ScrollTrigger.refresh(); } catch(_){} }, 50);

    // Remove guard shortly after animations complete
    setTimeout(() => document.body.classList.remove('nav-scroll-guard'), 600);

    restoreNavScrollEnabled = null;
  }

  if (logo && navModal) {
    logo.addEventListener('click', () => {
      if (navModal.classList.contains('active')) {
        closeModal();
      } else {
        openModal();
      }
    });

    navModal.addEventListener('click', (e) => {
      if (e.target === navModal) {
        closeModal();
      }
    });

    // Close modal and follow link when a link in .links-list is clicked
    navModal.querySelectorAll('.links-list a').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
        // Wait for modal close animation, then follow link
        setTimeout(() => {
          window.location.href = this.href;
        }, 400); // Match your modal transition duration
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });
  }

  // --- Play nav .logo .close-nav-video on hover only, and play backwards on mouseleave ---
  const closeNavVideo = document.querySelector('nav .logo video.close-nav-video');
  if (closeNavVideo) {
    closeNavVideo.pause();
    closeNavVideo.currentTime = 0;
    closeNavVideo.muted = true;
    closeNavVideo.removeAttribute('autoplay');
    closeNavVideo.removeAttribute('loop');
    const logoParent = closeNavVideo.closest('.logo');
    let reverseInterval = null;
    if (logoParent) {
      logoParent.addEventListener('mouseenter', () => {
        if (reverseInterval) {
          clearInterval(reverseInterval);
          reverseInterval = null;
        }
        closeNavVideo.currentTime = 0;
        closeNavVideo.playbackRate = 1;
        closeNavVideo.play();
      });
      logoParent.addEventListener('mouseleave', () => {
        closeNavVideo.pause();
        closeNavVideo.playbackRate = 1;
        reverseInterval = setInterval(() => {
          if (closeNavVideo.currentTime > 0.03) {
            closeNavVideo.currentTime -= 0.033;
          } else {
            closeNavVideo.currentTime = 0;
            clearInterval(reverseInterval);
            reverseInterval = null;
          }
        }, 33);
      });
      logoParent.addEventListener('focus', () => {
        if (reverseInterval) {
          clearInterval(reverseInterval);
          reverseInterval = null;
        }
        closeNavVideo.currentTime = 0;
        closeNavVideo.playbackRate = 1;
        closeNavVideo.play();
      });
      logoParent.addEventListener('blur', () => {
        closeNavVideo.pause();
        closeNavVideo.currentTime = 0;
        if (reverseInterval) {
          clearInterval(reverseInterval);
          reverseInterval = null;
        }
      });
    }
  }

  // --- Idle loop for .open-nav-video: wait 5s, play to end, hold 2s, reverse to start, repeat ---
  const openNavVideo = document.querySelector('nav .logo video.open-nav-video');
  if (openNavVideo && !openNavVideo.dataset.customLoop) {
    openNavVideo.dataset.customLoop = 'true';
    openNavVideo.muted = true;
    // Control playback manually
    openNavVideo.removeAttribute('loop');
    openNavVideo.removeAttribute('autoplay');
    try { openNavVideo.pause(); } catch (_) {}

    const logoEl = openNavVideo.closest('.logo');

    const waitForMetadata = () => new Promise((res) => {
      if (openNavVideo.readyState >= 1 && isFinite(openNavVideo.duration)) return res();
      openNavVideo.addEventListener('loadedmetadata', () => res(), { once: true });
    });

    // Track timers/listeners so we can cancel when hovering
    let idleTimeoutId = null;
    let holdTimeoutId = null;
    let reverseIntervalId = null;
    let timeUpdateHandler = null;
    let loopToken = 0; // increment to cancel current loop

    function clearLoopTimers() {
      if (idleTimeoutId) { clearTimeout(idleTimeoutId); idleTimeoutId = null; }
      if (holdTimeoutId) { clearTimeout(holdTimeoutId); holdTimeoutId = null; }
      if (reverseIntervalId) { clearInterval(reverseIntervalId); reverseIntervalId = null; }
      if (timeUpdateHandler) {
        openNavVideo.removeEventListener('timeupdate', timeUpdateHandler);
        timeUpdateHandler = null;
      }
    }

    function playForwardToEnd(currentToken) {
      return new Promise((resolve) => {
        timeUpdateHandler = () => {
          if (currentToken !== loopToken) { // cancelled
            openNavVideo.removeEventListener('timeupdate', timeUpdateHandler);
            timeUpdateHandler = null;
            return resolve();
          }
          if ((openNavVideo.duration - openNavVideo.currentTime) <= 0.05) {
            openNavVideo.pause();
            openNavVideo.currentTime = openNavVideo.duration;
            openNavVideo.removeEventListener('timeupdate', timeUpdateHandler);
            timeUpdateHandler = null;
            resolve();
          }
        };
        try { openNavVideo.playbackRate = 1; openNavVideo.play(); } catch (_) {}
        openNavVideo.addEventListener('timeupdate', timeUpdateHandler);
      });
    }

    function reverseToStart(currentToken) {
      return new Promise((resolve) => {
        reverseIntervalId = setInterval(() => {
          if (currentToken !== loopToken) {
            clearInterval(reverseIntervalId);
            reverseIntervalId = null;
            return resolve();
          }
          if (openNavVideo.currentTime > 0.033) {
            openNavVideo.currentTime = Math.max(0, openNavVideo.currentTime - 0.033);
          } else {
            clearInterval(reverseIntervalId);
            reverseIntervalId = null;
            openNavVideo.currentTime = 0;
            resolve();
          }
        }, 33);
      });
    }

    async function startOpenLoop() {
      await waitForMetadata();
      openNavVideo.currentTime = 0;
      try { openNavVideo.pause(); } catch (_) {}
      const myToken = ++loopToken;
      while (myToken === loopToken) {
        await new Promise((r) => { idleTimeoutId = setTimeout(r, 5000); });
        if (myToken !== loopToken) break;
        await playForwardToEnd(myToken);
        if (myToken !== loopToken) break;
        // Hold end frame (reduced from 2000ms to 1000ms)
        await new Promise((r) => { holdTimeoutId = setTimeout(r, 1000); });
        if (myToken !== loopToken) break;
        await reverseToStart(myToken);
      }
    }

    // Hover interaction: interrupt loop and play forward immediately
    if (logoEl && !logoEl.dataset.openVideoHoverBound) {
      logoEl.dataset.openVideoHoverBound = 'true';
      logoEl.addEventListener('mouseenter', () => {
        // cancel current loop and play forward immediately
        loopToken++; // invalidate any awaiting steps
        clearLoopTimers();
        try { openNavVideo.playbackRate = 1; openNavVideo.play(); } catch (_) {}
      });
      logoEl.addEventListener('mouseleave', () => {
        // resume loop from current state
        clearLoopTimers();
        startOpenLoop();
      });
    }

    // Kick off the loop
    startOpenLoop();
  }

  // --- iOS pull-down overscroll fix: switch nav to absolute so it rubber-bands with content ---
  (function(){
    if (!nav) return;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (!isIOS) return; // limit to iOS where rubber-band occurs
    let touchStartY = 0;
    let overscrolling = false;
    let originalPosition = getComputedStyle(nav).position;

    function enterOverscroll(){
      if (overscrolling) return;
      overscrolling = true;
      nav.dataset.originalPosition = originalPosition;
      nav.style.position = 'absolute';
      nav.style.top = '0';
      nav.style.left = '0';
      nav.style.right = '0';
    }
    function exitOverscroll(){
      if (!overscrolling) return;
      overscrolling = false;
      nav.style.position = nav.dataset.originalPosition || 'fixed';
    }

    window.addEventListener('touchstart', e => {
      touchStartY = e.touches[0].clientY;
      if (window.scrollY <= 0) {
        // prepare to potentially enter overscroll
        originalPosition = getComputedStyle(nav).position;
      }
    }, { passive: true });

    window.addEventListener('touchmove', e => {
      if (window.scrollY <= 0) {
        const dy = e.touches[0].clientY - touchStartY;
        if (dy > 6) { // pulling down
          enterOverscroll();
        }
      } else if (overscrolling) {
        exitOverscroll();
      }
    }, { passive: true });

    window.addEventListener('touchend', () => {
      if (overscrolling) {
        // give a frame for bounce to settle then restore
        requestAnimationFrame(() => {
          if (window.scrollY > 0) exitOverscroll();
          else setTimeout(exitOverscroll, 250);
        });
      }
    });
    window.addEventListener('scroll', () => {
      if (overscrolling && window.scrollY > 0) exitOverscroll();
    }, { passive: true });
  })();
}

function animateTwentyFive(twentyFive) {
  // Fade in .twenty-five on load
  gsap.fromTo(
    twentyFive,
    { opacity: 0, filter: 'blur(8px)', x: -20 },
    { opacity: 1, filter: 'blur(0px)', x: 0, duration: 0.7, ease: "power2.out" }
  );
  // Play the animation immediately after SVG is ready and faded in
  const lottieInstance = lottie.getRegisteredAnimations().find(anim => anim.wrapper === twentyFive);
  if (lottieInstance) lottieInstance.play();
}